module.exports = __webpack_public_path__ + "static/media/request_2.3418f9f5.svg";